module.exports = __webpack_public_path__ + "img/aboutFTrade.2e9c10c4.jpg";